export default __webpack_public_path__ + "media/images/fonts/materialdesignicons-webfont-246a512d70416108683f9f190d3dd1a6.ttf";